export enum CreditType {
    Visa = 1,
    Installment = 2,
}
